import { render, staticRenderFns } from "./PhoneAdvancedProps.vue?vue&type=template&id=3cbf7e96"
import script from "./PhoneAdvancedProps.vue?vue&type=script&lang=js"
export * from "./PhoneAdvancedProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports